import { ApiError } from './api'

// Rótulos em português pros campos que aparecem em errors[] (validação @Valid do backend --
// ver ApiExceptionHandler.validation). Campo sem entrada aqui cai no próprio nome do campo,
// ainda assim melhor que sumir a mensagem inteira.
const FIELD_LABELS: Record<string, string> = {
  email: 'E-mail',
  name: 'Nome',
  phone: 'Telefone',
  segment: 'Segmento',
  notes: 'Notas',
  fromAddress: 'Remetente',
  subject: 'Assunto',
  htmlBody: 'Corpo da mensagem',
  textBody: 'Corpo da mensagem',
  code: 'Código',
  priceCents: 'Preço',
  maxAttachments: 'Máximo de anexos',
  maxAttachmentBytes: 'Tamanho máximo por arquivo',
  maxTotalBytes: 'Tamanho máximo total',
  maxContacts: 'Máximo de contatos',
  maxMessagesPerMonth: 'Máximo de envios por mês',
  domain: 'Domínio',
  domainId: 'Domínio',
  localPart: 'Endereço',
  displayName: 'Nome de exibição',
  password: 'Senha',
  quotaBytes: 'Cota',
  sourceLocalPart: 'Endereço de origem',
  destinationAddress: 'Endereço de destino',
  to: 'Destinatários',
  cc: 'Cópia',
  bcc: 'Cópia oculta',
  inReplyTo: 'Em resposta a',
  slug: 'Slug',
  logoDataUri: 'Logomarca',
  planCode: 'Plano',
  scheduledAt: 'Data de agendamento',
  contactIds: 'Destinatários',
  lines: 'Linhas',
  username: 'Usuário',
  role: 'Papel',
}

// Traduz as mensagens padrão do Hibernate Validator (Bean Validation) que o backend ainda
// não customiza -- só as que realmente aparecem nos DTOs deste projeto (@NotBlank, @Email,
// @Size, @Min, @Positive, @NotNull; ver grep dessas anotações em src/main/java).
const MESSAGE_RULES: [RegExp, string][] = [
  [/^must not be blank$/i, 'não pode ficar em branco'],
  [/^must not be null$/i, 'é obrigatório'],
  [/^must be a well-formed email address$/i, 'não é um e-mail válido'],
  [/^size must be between (\d+) and (\d+)$/i, 'deve ter entre $1 e $2 caracteres'],
  [/^must be greater than or equal to (\d+(?:\.\d+)?)$/i, 'deve ser maior ou igual a $1'],
  [/^must be greater than (\d+(?:\.\d+)?)$/i, 'deve ser maior que $1'],
  [/^must be less than or equal to (\d+(?:\.\d+)?)$/i, 'deve ser menor ou igual a $1'],
]

function translate(raw: string): string {
  for (const [pattern, replacement] of MESSAGE_RULES) if (pattern.test(raw)) return raw.replace(pattern, replacement)
  return raw
}

// Ponto único pra transformar qualquer erro de chamada à API numa frase que faz sentido pro
// usuário -- nunca "Erro HTTP 403" nem um JSON cru. Usar em todo `{mutation.error && ...}`
// no lugar de `mutation.error.message` direto.
export function friendlyMessage(error: unknown): string {
  if (!(error instanceof ApiError)) return 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.'

  const fieldErrors = error.problem?.errors
  if (fieldErrors?.length) return fieldErrors.map((e) => `${FIELD_LABELS[e.field] ?? e.field}: ${translate(e.message)}`).join(' • ')

  if (error.problem?.detail) return error.problem.detail

  switch (error.status) {
    case 401: return 'Sua sessão expirou. Faça login novamente.'
    case 403: return 'Você não tem permissão para executar essa ação.'
    case 404: return 'Não encontrado.'
    case 409: return 'Já existe um registro com esses dados.'
    case 429: return 'Muitas tentativas em pouco tempo. Aguarde um instante e tente de novo.'
    default: return error.status >= 500 ? 'Erro no servidor. Tente novamente em instantes.' : 'Não foi possível completar a ação. Tente novamente.'
  }
}
